import { render } from "./ToastWrapper.vue?vue&type=template&id=dd960af0&scoped=true&lang=pug"
import script from "./ToastWrapper.vue?vue&type=script&lang=js"
export * from "./ToastWrapper.vue?vue&type=script&lang=js"

import "./ToastWrapper.vue?vue&type=style&index=0&id=dd960af0&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd960af0"]])

export default __exports__